
import { BlogPost } from '@/types/blog';
import { post as introducingFordjeReports } from './introducing-fordje-reports';
import { post as goingAllInOnCleanEnergy } from './going-all-in-on-clean-energy';
import { post as codeConfusion121B } from './121b-code-confusion';
import { post as fordjeSelectedForLaciIncubationCohort } from './fordje-selected-for-laci-incubation-cohort';
import { post as deepDiveDesignAndEngineering } from './deep-dive-design-and-engineering';
import { post as introducingFordjesNewDevPlatform } from './introducing-fordjes-new-developer-platform';
import { post as chatgptVsFordje } from './chatgpt-vs-fordje';
import { post as industryPerspective } from './industry-perspective';
import { post as buildCosts } from './build-costs';
import { post as fireCodeEssentials } from './fire-code-essentials';
import { post as protectingLaCommunities } from './protecting-la-communities';
import { post as iCodesAdoption } from './i-codes-adoption';
import { post as buildLifecycleGuide } from './build-lifecycle-guide';
import { post as howBuildingCodesAreShaping } from './how-building-codes-are-shaping-the-residential-solar-and-storage-industry';
import { post as changingPoliciesAndEconomicShifts } from './changing-policies-and-economic-shifts';
import { post as rejectionRatesCostsAndRegulatoryChanges } from './rejection-rates-costs-and-regulatory-changes';
import { post as municipalCodesThatLeadToPermitRejections } from './municipal-codes-that-lead-to-permit-rejections';
import { post as deepDiveSiteAssessment } from './deep-dive-site-assessment';
import { post as deepDiveProspecting } from './deep-dive-how-teams-use-fordje-for-prospecting';
import { post as homeRuleProblem } from './home-rule-problem';
import { post as howToTestFordjeData } from './how-to-test-fordje-data';
import { post as buildingCodesReport2026 } from './2026-building-codes-report';
import { post as caSolarPermitFeeCap2026 } from './california-solar-permit-fee-cap-2026';
import { post as caBessSitingCycle } from './california-bess-siting-cycle';
import { post as paDataCenterCleanEnergy } from './pennsylvania-data-center-clean-energy';

// Collect all blog posts
export const blogPosts: BlogPost[] = [
  paDataCenterCleanEnergy, // (September 14, 2026)
  caBessSitingCycle, // (September 3, 2026)
  caSolarPermitFeeCap2026, // (August 6, 2026)
  goingAllInOnCleanEnergy, // (July 20, 2026)
  introducingFordjeReports, // (February 5, 2026)
  buildingCodesReport2026, // (January 14, 2026) - Report
  howToTestFordjeData, // (January 6, 2026)
  homeRuleProblem, // (October 22, 2025)
  codeConfusion121B, // (October 14, 2025)
  deepDiveDesignAndEngineering, // (June 24, 2025)
  fordjeSelectedForLaciIncubationCohort, // (June 17, 2025)
  deepDiveSiteAssessment, // (June 16, 2025)
  deepDiveProspecting, // (June 3, 2025)
  chatgptVsFordje,
  industryPerspective,
  buildCosts,
  fireCodeEssentials,
  protectingLaCommunities,
  iCodesAdoption,
  introducingFordjesNewDevPlatform, // (December 1, 2024)
  howBuildingCodesAreShaping, // (November 7, 2024)
  buildLifecycleGuide,
  changingPoliciesAndEconomicShifts, // (October 29, 2024)
  rejectionRatesCostsAndRegulatoryChanges, // (October 14, 2024)
  municipalCodesThatLeadToPermitRejections // (September 19, 2024)
];

// Helper function to get a post by slug
export const getPostBySlug = (slug: string): BlogPost | undefined => {
  return blogPosts.find(post => post.slug === slug);
};

// Helper function to get posts sorted by date (newest first)
export const getSortedPosts = (): BlogPost[] => {
  return [...blogPosts].sort((a, b) => 
    new Date(b.date).getTime() - new Date(a.date).getTime()
  );
};

// Helper function to get posts by category
export const getPostsByCategory = (category: string): BlogPost[] => {
  return blogPosts.filter(post => 
    post.categories.includes(category)
  ).sort((a, b) => 
    new Date(b.date).getTime() - new Date(a.date).getTime()
  );
};
